import { CustomNumber } from '../CustomNumber/CustomNumber';
import { CurrencySymbolEnum } from '../../constants/enums';

export const AlignTotal = ({
  symbol,
  totalValue,
}: {
  symbol: CurrencySymbolEnum;
  totalValue: number;
}) => {
  return (
    <div
      className={`
        grid
        grid-cols-7
        h-12
        w-full
        bg-lime
        mt-auto
        items-center
        px-5
        font-medium
      `}
    >
      <span className="flex col-span-5 dark:text-black">TOTAL</span>
      <CustomNumber
        className="col-span-2 bg-transparent ml-8 font-medium dark:text-black"
        allowNegative={false}
        prefix={totalValue < 0 ? '-' : totalValue > 0 ? '+' : undefined}
        suffix={symbol}
        value={totalValue !== 0 ? totalValue : undefined}
      />
    </div>
  );
};
